module.exports = __webpack_public_path__ + "media/images/org_footer_background_image-99c64483068fbfd8992d087e8f5ff1ea.jpeg";